import React from 'react';
import { Box, Chip } from '@mui/material';
import { GroupedUserGuideScopeRow } from '../types';
import { USER_GUIDE_ORDER_ALL_KEY } from '../../../../../gql/userGuideScopes';

interface OrderedScopeChipsProps {
    groups: GroupedUserGuideScopeRow[];
    selectedScopeId: string;
    onSelectScope: (scopeId: string) => void;
}

const OrderedScopeChips: React.FC<OrderedScopeChipsProps> = ({
    groups,
    selectedScopeId,
    onSelectScope,
}) => (
    <Box
        sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            mt: 2,
        }}
    >
        <Chip
            label="All"
            variant={
                selectedScopeId === USER_GUIDE_ORDER_ALL_KEY
                    ? 'solid'
                    : 'outlined'
            }
            color={
                selectedScopeId === USER_GUIDE_ORDER_ALL_KEY
                    ? 'primary'
                    : 'default'
            }
            onClick={() => onSelectScope(USER_GUIDE_ORDER_ALL_KEY)}
        />
        {groups.map((group) => (
            <Chip
                key={group._id}
                label={group.name}
                variant={selectedScopeId === group._id ? 'solid' : 'outlined'}
                color={selectedScopeId === group._id ? 'primary' : 'default'}
                onClick={() => onSelectScope(group._id)}
            />
        ))}
    </Box>
);

export default OrderedScopeChips;
